import jMoment from 'moment-jalaali';
import { FILTER_TYPES } from 'components/FilterPod';

const filters = (currencyText) => [
  {
    title: 'محدوده تاریخ',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'dateRange',
    id: {
      start: null,
      end: null,
    },
    value: {
      start: jMoment(new Date().setHours(0, 0, 0, 0)).subtract(7, 'days'),
      end: jMoment(new Date().setHours(23, 59, 0, 0)),
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
    disableDelete: true,
  },
  {
    title: 'نام و نام‌خانوادگی',
    label: 'نام و نام‌خانوادگی',
    keyName: 'fullName',
    id: 1657,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
  {
    title: 'تلفن همراه',
    label: 'تلفن همراه',
    keyName: 'phoneNumber',
    id: 1658,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    title: 'محدوده‌ مبلغ مورد نظر',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'amountRange',
    id: {
      start: 1650,
      end: 1651,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    title: 'محدوده میزان استفاده شده',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    unit: currencyText,
    keyName: 'usedRange',
    id: {
      start: 1652,
      end: 1653,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
  },
  {
    title: 'محدوده میزان مانده',
    label: {
      start: 'از مبلغ',
      end: 'تا مبلغ',
    },
    keyName: 'remainRange',
    id: {
      start: 1654,
      end: 1655,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.textRange,
    filterProps: {
      start: {
        currency: true,
      },
      end: {
        currency: true,
      },
    },
    unit: currencyText,
  },
  {
    title: 'شناسه اعتبار',
    label: 'شناسه اعتبار',
    keyName: 'creditId',
    id: 1646,
    value: null,
    filterType: FILTER_TYPES.text,
  },
  {
    title: 'شناسه مشتری',
    label: 'شناسه مشتری',
    keyName: 'userId',
    id: 1656,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    // TODO: is the oprions currect?
    title: 'براساس وضعیت',
    label: 'براساس وضعیت',
    keyName: 'status',
    id: 1649,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'فعال',
          label: 'فعال',
        },
        {
          value: 'غیرفعال',
          label: 'غیرفعال',
        },
      ],
    },
  },
  {
    // TODO: is the oprions currect?
    title: 'دوره',
    label: 'دوره',
    keyName: 'period',
    id: 1664,
    value: null,
    filterType: FILTER_TYPES.select,
    filterProps: {
      options: [
        {
          value: 'سالانه',
          label: 'سالانه',
        },
        {
          value: 'ماهانه',
          label: 'ماهانه',
        },
        {
          value: 'هفتگی',
          label: 'هفتگی',
        },
        {
          value: 'روزانه',
          label: 'روزانه',
        },
        {
          value: 'بدون دوره',
          label: 'بدون دوره',
        },
      ],
    },
  },
  {
    title: 'تعداد شارژ مجدد',
    label: 'تعداد شارژ مجدد',
    keyName: 'rechargeCount',
    id: 1663,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {
      englishNumber: true,
    },
  },
  {
    title: 'محدوده‌ زمان شروع',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'startDateRange',
    id: {
      start: 1659,
      end: 1660,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  {
    title: 'محدوده‌ زمان انقضا',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'expireDateRange',
    id: {
      start: 1661,
      end: 1662,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },

  {
    title: 'محدوده‌ زمان ایجاد',
    label: {
      start: 'از تاریخ',
      end: 'تا تاریخ',
    },
    keyName: 'createDateRange',
    id: {
      start: 1647,
      end: 1648,
    },
    value: {
      start: null,
      end: null,
    },
    filterType: FILTER_TYPES.dateRange,
    filterProps: {
      start: {},
      end: {},
    },
  },
  {
    title: 'جستجو در توضیحات',
    label: 'توضیحات',
    keyName: 'description',
    id: 1665,
    value: null,
    filterType: FILTER_TYPES.text,
    filterProps: {},
  },
];

export default filters;
